import React, { useEffect, useState} from "react";
import { createPortal } from 'react-dom';
import moment from 'moment';
import store from "@/redux/store";

import { Switch, Field } from '@headlessui/react'
import {SelectBox} from '@/components/holders/SelectBox'
import {FieldHolder} from "@/components/holders/FieldHolder";

export function CustomerSelect({...props}) {
    const customers = store.getState().AuthReducer.customers;
    const [selected, setSelected] = useState();
    const [filter, setFilter] = useState({name: ''});
    
    useEffect(() => {



    
        return () => {
            
        };
    }, []);

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
    
    const changeEventOnCustomer =((name, selected) => {
        if(selected) {
            setSelected(selected);
                if(props.onChangeEvent) {
                    props.onChangeEvent(name, selected);
                }
            } else {
                setSelected(selected);
            }
        });

    
    return (<>
    <FieldHolder colspan="12" smcolspan="12" label={"Klant"} id="name" error={props?.state?.error}>
        <SelectBox className="" name="customer" data={customers} boxfield="name" boxfieldSub="" changeEvent={changeEventOnCustomer} selected={props?.selected} emptyOption={props?.emptyOption}/>
    </FieldHolder>
    
    </>)

}
    